import { useState } from "react";
import LetterTemplateBuilder from "./LetterTemplateBuilder";
import { LetterFormatsTable, LetterTemplatesTable, LetterToEmployeeTable } from "./LetterTemplateTables";

const LetterBuilder = () => {

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Letter Templates';
            case 2:
                return 'Letter Formats';
            case 3:
                return 'Employee Letters';
            default:
                return 'Letter Builder';
        }
    };
    return (
        <>
            <div>
                <div className="bloc-tabss  wfm-margin" style={{ marginLeft: '30px' }}>
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(1)}
                    >
                        Letter Templates
                    </button>
                    <button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(2)}
                    >
                        Letter Formats
                    </button>
                    <button
                        className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                        onClick={() => setToggleState(3)}
                    >
                        Employee Letters
                    </button>
                </div>

                <div className="content-tabs">

                    {toggleState === 1 ? <LetterTemplatesTable /> : null}

                    {toggleState === 2 ? <LetterFormatsTable /> : null}

                    {toggleState === 3 ? <LetterToEmployeeTable /> : null}

                </div>
            </div>

        </>
    )
}

export default LetterBuilder
